
import React from 'react';
import { Activity, BarChart2, Clock, AlertCircle } from 'lucide-react';

const PerformanceMonitoringSection = () => {
  return (
    <section className="py-20 bg-white md:mb-20">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="order-1 lg:order-2">
            <h2 className="text-3xl md:text-4xl font-bold mb-6">
              Suivez les performances de votre application
            </h2>
            <p className="text-lg text-slate-600 mb-8">
              Surveillez en temps réel les performances de votre application 
              et recevez des alertes en cas de problème.
            </p>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <Activity className="w-6 h-6 text-orcsys-500 mt-1" />
                <div>
                  <h3 className="font-semibold text-slate-900">Métriques en temps réel</h3>
                  <p className="text-slate-600">Suivez les performances en direct</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <BarChart2 className="w-6 h-6 text-orcsys-500 mt-1" />
                <div>
                  <h3 className="font-semibold text-slate-900">Graphiques détaillés</h3>
                  <p className="text-slate-600">Visualisez les données sur des graphiques</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <AlertCircle className="w-6 h-6 text-orcsys-500 mt-1" />
                <div>
                  <h3 className="font-semibold text-slate-900">Alertes automatiques</h3>
                  <p className="text-slate-600">Soyez notifié en cas de problème</p>
                </div>
              </div>
            </div>
          </div>

          {/* Device Mockup - Hidden on mobile */}
          <div className="hidden lg:block order-2 lg:order-1 relative">
            <div className="relative mx-auto w-full max-w-[600px] md:max-w-[800px]">
              <div className="absolute inset-0 bg-gradient-to-r from-orcsys-100 to-orcsys-200 rounded-xl blur-xl opacity-50 animate-pulse-soft"></div>
              <div className="relative bg-white rounded-xl shadow-xl overflow-hidden border border-gray-100">
                {/* Screen Content */}
                <div className="aspect-[16/11] bg-gradient-to-br from-orcsys-50 to-white overflow-hidden">
                  <img 
                    src="images/collab-stats-desktop.png" 
                    alt="Performance dashboard"
                    className="w-full h-full object-fill"
                  />
                </div>
                {/* Base */}
                <div className="h-3 md:h-4 bg-slate-100"></div>
              </div>
            </div>

            {/* Phone Mockup */}
            <div className="absolute -bottom-4 md:-bottom-8 -right-4 md:-right-8 w-32 h-64 md:w-48 md:h-96">
              <div className="relative">
                <div className="absolute inset-0 bg-gradient-to-r from-orcsys-100 to-orcsys-200 rounded-xl blur-xl opacity-50 animate-pulse-soft"></div>
                <div className="relative bg-white rounded-[1.5rem] md:rounded-[2rem] shadow-xl overflow-hidden border border-gray-100">
                  {/* Phone Notch */}
                  <div className="h-4 md:h-6 bg-slate-900 rounded-t-[1.5rem] md:rounded-t-[2rem] flex items-center justify-center">
                    <div className="w-16 md:w-20 h-3 md:h-4 bg-slate-800 rounded-full"></div>
                  </div>
                  {/* Phone Screen */}
                  <div className="aspect-[9/18] bg-gradient-to-br from-orcsys-50 to-white overflow-hidden">
                    <img 
                      src="images/collab-stats-mobile.jpg" 
                      alt="Mobile analytics"
                      className="w-full h-full object-fill"
                    />
                  </div>
                  {/* Phone Home Button */}
                  <div className="h-8 md:h-12 bg-slate-100 border-t border-gray-200 flex items-center justify-center">
                    <div className="w-8 md:w-12 h-1 bg-slate-300 rounded-full"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PerformanceMonitoringSection;
